import { atom } from 'jotai';

/**
 * Reactive store for the active house override.
 * null  = no override active; effective house ID falls back to JWT houseId.
 * string = house ID the ATG admin has switched to.
 *
 * Initialized from the houseOverride cookie by HouseOverrideInitializer on app load.
 * Kept in sync with the cookie via useSwitchHouse.
 */
export const houseOverrideAtom = atom<string | null>(null);
